import { Component, OnInit, Inject, ElementRef, QueryList, ViewChildren } from '@angular/core';
import {MatDialogRef,MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ZonaService} from '../../../services/zona.service';
import {ReglasService} from '../../../services/reglas.service';
import {zona} from '../../../models/zona';
import {regla, FormData} from '../../../models/regla';
import {ProyectoService} from "../../../services/proyecto.service";
import {Localiser} from "../../../services/localiser";
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-new-regla',
  templateUrl: './new-regla.component.html',
  styleUrls: ['./new-regla.component.css']
})
export class NewReglaComponent implements OnInit {
  regla: FormData = {
    idRegla: 0,
    nombre: "",
    min_resto: undefined, // Example min value
    max_resto: undefined, // Example max value
    zonas: [],
    days_of_week: {
      Lunes: {
        tramos: [
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" },
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" },
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" }
        ]
      },
      Martes: {
        tramos: [
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" },
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" },
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" }
        ]
      },
      Miércoles: {
        tramos: [
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" },
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" },
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" }
        ]
      },
      Jueves: {
        tramos: [
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" },
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" },
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" }
        ]
      },
      Viernes: {
        tramos: [
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" },
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" },
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" }
        ]
      },
      Sábado: {
        tramos: [
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" },
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" },
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" }
        ]
      },
      Domingo: {
        tramos: [
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" },
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" },
          { min: undefined, max: undefined, h_inicio: "", h_fin: "" }
        ]
      }
    }
  };

  zonas: zona[];
  reglas: regla[];
  creating: boolean = false;
  errorsArray: string[] = [];
  addZones: boolean = false;
  searcherZonasFueraDeRegla = "";
  searcherZonasEnRegla = "";
  estados_semana = [];

  zonasFueraDeRegla: Array<zona> = [];
  zonasFueraDeReglaReal: Array<zona> = [];
  zonasEnRegla: Array<zona> = [];
  zonasEnReglaReal: Array<zona> = [];

  week = {
    0: "Lunes",
    1: "Martes",
    2: "Miércoles",
    3: "Jueves",
    4: "Viernes",
    5: "Sábado",
    6: "Domingo"
  };

  constructor(public dialogRef: MatDialogRef<NewReglaComponent>,
              private zonaService: ZonaService,
              private reglasService: ReglasService,
              private proyectoService: ProyectoService,
              public localiser: Localiser,
              @Inject(MAT_DIALOG_DATA) public data: { idRegla: number }) { }

  ngOnInit(): void {
    this.zonaService.getByIdProyectoDTO(this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
      this.zonas = <Array<zona>> result;

      this.reglasService.getAll().subscribe(result => {
        this.reglas = <Array<regla>> result;

        if (this.data != undefined && this.data.idRegla != undefined && !isNaN(this.data.idRegla) && this.data.idRegla != 0) {
          if (this.data.idRegla != 0) {
            this.reglasService.getByIdRegla(this.data.idRegla).subscribe((result: FormData) => {
              this.regla = result;
              let lista_zonas_regla = [];
              for (let zona_regla of this.regla.zonas) {
                for (let zona_dto of this.zonas) {
                  if (zona_dto.id == zona_regla.id) {
                    lista_zonas_regla.push(zona_dto);
                    break;
                  }
                }
              }
              this.zonasEnRegla = lista_zonas_regla;
              this.zonasFueraDeReglaReal = this.zonas.filter(zona => zona.regla != this.regla.idRegla);
              this.zonasEnReglaReal = this.zonasEnRegla;
              this.zonasFueraDeRegla = this.zonasFueraDeReglaReal;
            }, error => {
              this.creating = false;
            })
          }
        } else {
          this.zonasEnRegla = [];
          this.zonasFueraDeReglaReal = this.zonas;
          this.zonasEnReglaReal = this.zonasEnRegla;
          this.zonasFueraDeRegla = this.zonasFueraDeReglaReal;
        }
      })
    })
  }

  getTimeValue(timeInMinutes: number): string {
    const hours = Math.floor(timeInMinutes / 60).toString().padStart(2, '0');
    const minutes = (timeInMinutes % 60).toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  getRuleField(id: number, campo: string) {
    let value = undefined;

    for (let regla of this.reglas) {
      if (regla.idRegla == id && regla[campo] != undefined) {
        value = regla[campo];
        break;
      }
    }

    return value;
  }

  addZonaToRegla(zona: zona) {
    this.zonasFueraDeReglaReal = this.zonasFueraDeReglaReal.filter(zona_listado => zona_listado.id != zona.id);
    this.zonasEnReglaReal.push(zona);
    this.zonasFueraDeRegla = this.zonasFueraDeReglaReal;
    this.zonasEnRegla = this.zonasEnReglaReal;
  }

  removeZonaFromRegla(zona: zona) {
    this.zonasEnReglaReal = this.zonasEnReglaReal.filter(zona_listado => zona_listado.id != zona.id);
    this.zonasFueraDeReglaReal.push(zona);
    this.zonasEnRegla = this.zonasEnReglaReal;
    this.zonasFueraDeRegla = this.zonasFueraDeReglaReal;
  }

  tryCreateRegla() {
    if (this.checkCreationRegla()) {
      this.createRegla();
    } else {
      this.getErrorsCreatingRegla();
    }
  }

  createRegla() {
    let regla_to_bd: regla = {
      idRegla: this.regla.idRegla,
      nombre: this.regla.nombre,
      zonas: this.zonasEnRegla,
      activa: false,
      min_resto: this.regla.min_resto,
      max_resto: this.regla.max_resto,
      days_of_week: this.regla.days_of_week
    }

    this.creating = true;
    this.errorsArray = [];
    this.reglasService.new(regla_to_bd).subscribe(result => {
      this.dialogRef.close();
    }, error => {
      this.errorsArray.push(this.localiser.get('rules.create.error'));
      this.creating = false;
    })
  }

  openZonesModal() {
    this.addZones = !this.addZones;
  }

  searcherZonasFueraDeReglaFunc() {
    this.zonasFueraDeRegla = this.zonasFueraDeReglaReal.filter(zona =>
      zona.nombre.toLowerCase().includes(this.searcherZonasFueraDeRegla.toLowerCase()));
  }

  searcherZonasEnReglaFunc() {
    this.zonasEnRegla = this.zonasEnReglaReal.filter(zona =>
      zona.nombre.toLowerCase().includes(this.searcherZonasEnRegla.toLowerCase()));
  }

  getErrorsCreatingRegla() {
    this.errorsArray = [];

    Object.keys(this.regla.days_of_week).forEach(day_of_week => {
      if (this.hasOverlappingSegments(this.regla.days_of_week[day_of_week].tramos)) {
        this.errorsArray.push(`For ${day_of_week} review the overlapping time segments`);
      }

      let estado_tramos = [false, false, false];
      let estado_tramos_llenos = [false, false, false];

      for (let tramo of [0,1,2]) {
        const dato_tramo = this.regla.days_of_week[day_of_week].tramos[tramo];
        this.checkTramo(tramo, dato_tramo, estado_tramos, estado_tramos_llenos, this.errorsArray, day_of_week);
      }
    });

    if (this.regla.min_resto == undefined || this.regla.max_resto == undefined) {
      this.errorsArray.push(this.localiser.get("rules.resto.empty"));
    }

    if (this.regla.min_resto != undefined && this.regla.max_resto != undefined) {
      if (this.regla.min_resto > this.regla.max_resto) {
        this.errorsArray.push(this.localiser.get("rules.resto.minhigherthanmax"));
      }

      if (this.regla.min_resto < 0 || this.regla.max_resto > 100) {
        this.errorsArray.push(this.localiser.get("rules.resto.minmaxvalidvalues"));
      }
    }
  }

  hasOverlappingSegments(segments) {
    // First, convert h_inicio and h_fin to Date objects (or minutes since midnight)
    const toMinutes = (timeStr) => {
      const [hours, minutes] = timeStr.split(":").map(Number);
      return hours * 60 + minutes;
    };

    // Sort segments by start time
    const sorted = [...segments].sort(
      (a, b) => toMinutes(a.h_inicio) - toMinutes(b.h_inicio)
    );

    for (let i = 1; i < sorted.length; i++) {
      const prevEnd = toMinutes(sorted[i - 1].h_fin);
      const currentStart = toMinutes(sorted[i].h_inicio);

      if (currentStart < prevEnd) {
        return true; // Overlap or no gap
      }
    }

    return false; // No overlaps
  }

  isValidNumber = (num: number) => Number.isInteger(num) && num >= 0 && num <= 100;

  // Helper function to compare time strings
  isTimeValid = (start: string, end: string): boolean => {
    if (!start || !end) return false;
    const [sh, sm] = start.split(":").map(Number);
    const [eh, em] = end.split(":").map(Number);
    return sh < eh || (sh === eh && sm < em);
  };

  checkTramo(tramo_i: number, tramo: any, estado_tramos: boolean[], estado_tramos_llenos: boolean[], errorsArray: string[], day_of_week: string) {
    if (tramo_i == 0 || (tramo_i > 0 && estado_tramos[tramo_i - 1])) {
      if (tramo.min == undefined && tramo.max == undefined && tramo.h_inicio == "" && tramo.h_fin == "") {
        estado_tramos[tramo_i] = true;
        estado_tramos_llenos[tramo_i] = false;
      } else {
        estado_tramos_llenos[tramo_i] = true;
      }

      let estado_min = this.isValidNumber(tramo.min);
      let estado_max = this.isValidNumber(tramo.max);
      let estado_tiempo = this.isTimeValid(tramo.h_inicio, tramo.h_fin);

      if (estado_min && estado_max && estado_tiempo) {
        if (tramo.min <= tramo.max) {
          estado_tramos[tramo_i] = true;
        }
      }

      if (errorsArray != undefined) {
        if ((tramo.min == undefined && tramo.max != undefined) || (tramo.min != undefined && tramo.max == undefined)) {
          this.errorsArray.push(this.localiser.format(this.localiser.get("rules.error.emptyminmax"), { day_of_week: day_of_week, segment: (Number(tramo_i)+1).toString() }));
        }

        if (tramo.min != undefined && tramo.max != undefined && tramo.min > tramo.max) {
          this.errorsArray.push(this.localiser.format(this.localiser.get("rules.error.minhighertanmax"), { day_of_week: day_of_week, segment: (Number(tramo_i)+1).toString() }));
        }

        if (tramo.min < 0 || tramo.min > 100) {
          this.errorsArray.push(this.localiser.format(this.localiser.get("rules.error.minmaxvalidvalues"), { day_of_week: day_of_week, segment: (Number(tramo_i)+1).toString() }));
        }

        if (!estado_tiempo && !estado_tramos[tramo_i]) {
          this.errorsArray.push(this.localiser.format(this.localiser.get("rules.error.startendtime"), { day_of_week: day_of_week, segment: (Number(tramo_i)+1).toString() }));
        }
      }

      if (tramo_i > 0) {
        if (estado_tramos[tramo_i] && estado_tramos_llenos[tramo_i]) {
          if (estado_tramos[tramo_i - 1] && !estado_tramos_llenos[tramo_i - 1]) {
            estado_tramos[tramo_i] = false;

            if (errorsArray != undefined) {
              this.errorsArray.push(this.localiser.format(this.localiser.get("rules.error.emptysegment"), { day_of_week: day_of_week, segment: (Number(tramo_i)+1).toString(), segment2: Number(tramo_i).toString() }));
            }
          }
        }
      }
    }
  }

  checkCreationRegla(): boolean {
    if (!this.regla || typeof this.regla !== 'object') return false;

    // Validate resto_min and resto_max
    if (this.regla.min_resto == undefined || this.regla.max_resto == undefined) {
      return false;
    }

    if (this.regla.min_resto != undefined && this.regla.max_resto != undefined) {
      if (!this.isValidNumber(this.regla.min_resto) || !this.isValidNumber(this.regla.max_resto)) return false;

      if (this.regla.min_resto > this.regla.max_resto) {
        return false;
      }
    }

    // Validate each day's schedule
    for (const day of Object.values(this.regla.days_of_week)) {
      let estado_tramos = [false, false, false];
      let estado_tramos_llenos = [false, false, false];
      let tramo_i = 0;

      for (const timeRange of day.tramos) {
        this.checkTramo(tramo_i, timeRange, estado_tramos, estado_tramos_llenos, undefined, undefined);
        tramo_i++;
      }

      if (estado_tramos.some(tramo => !tramo)) {
        return false;
      }

      if (this.hasOverlappingSegments(day.tramos)) return false;
    }

    if (this.creating) return false;

    return !this.creating;
  }

  getDayOfWeekInText(day_of_week: number) {
    let day_of_week_text = "N/A";

    switch (day_of_week) {
      case 0:
        day_of_week_text = this.localiser.get("rules.weekday.monday");
      
        break;
      case 1:
        day_of_week_text = this.localiser.get("rules.weekday.tuesday");

        break;
      case 2:
        day_of_week_text = this.localiser.get("rules.weekday.wednesday");
        
        break;
      case 3:
        day_of_week_text = this.localiser.get("rules.weekday.thursday");
        
        break;
      case 4:
        day_of_week_text = this.localiser.get("rules.weekday.friday");
        
        break;
      case 5:
        day_of_week_text = this.localiser.get("rules.weekday.saturday");

        break;
      case 6:
        day_of_week_text = this.localiser.get("rules.weekday.sunday");

        break;
      default:
        break;
    }

    console.log(`day number ${day_of_week} and ${day_of_week_text}`);

    return day_of_week_text;
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  copyWeek() {
    for (let dia of Object.keys(this.regla.days_of_week)) {
      if (dia != "Lunes") {
        // this.regla.days_of_week[dia] = JSON.parse(JSON.stringify(this.regla.days_of_week["Lunes"]));
        this.regla.days_of_week[dia] = cloneDeep(this.regla.days_of_week["Lunes"]);
      }
    }
  }
}
